import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import CONSTANTS from "@/constants/index"
import Input from "@/components/core/Input/Input"
import Button from "@/components/core/Button/Button"
import { apim } from "@/constants/api"
import { validNumber } from "@/utils/validate"
import { isValidPincode, pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { getProductBySku } from "@/utils/product"
import { selectAuthState } from "@/store/features/authSlice"
import { getUserProfile } from "@/store/features/genericSlice"
import infoIcon from "@/public/icons/warning.svg"
import styles from "@/components/ProductDetail/v3/InstallService/index.module.scss"
import { getUserPersona } from "@/utils/helper"
import { getETACached } from "@/utils/cart"

const InstallService = ({
  sku = "",
  qty = "",
  i18n = {},
  masterSku = "",
  disableCart,
  setWareHouses,
  setAvailableQty,
  installServiceData,
  setInstallationData,
  isInstallationAvailable,
  isBundle = false,
  productInfo = {},
  setInstallProductInfo = () => {},
  installErrorCallback,
  setPinCodeError,
  pinCodeError,
  installationError,
  setInstallationError,
  error,
  setError,
  loading,
  setLoading,
  installReq = [],
  setReqItemsError,
  setPincodeValue = () => {},
  setNotifySuccess = () => {},
  setIsOutOfStock = () => {},
  setIsEtaLoading= ()=>{}
}) => {
  const [pincode, setPincode] = useState("")
  const [isAvailable, setAvailability] = useState(false)
  const [eta, setEta] = useState({ minDay: "", maxDay: "" })

  const [installationMsg, setInstallationMsg] = useState("")
  const [installationWarning, setInstallationWarning] = useState("")

  const [installationAvailable, setInstallationAvailable] = useState(false)
  const [hideSimilarItems, setHideSimilarItems] = useState(false)
  const dispatch = useDispatch()
  const {
    isAuth,
    user: { persona = ["IN_KOHLER_GST"] },
  } = useSelector(selectAuthState)
  const stopATCLoading = new Event("stop-loading-atc")

  useEffect(() => {
    if (installationError !== "" || installationWarning !== "") {
      installErrorCallback(true)
    } else {
      installErrorCallback(loading)
    }
  }, [installationError, installationWarning, loading])
  const element = document.getElementById("product-recs-AT-Similar-items")
  let showSimilarItems = false
  if (element) {
    showSimilarItems = true
  }
  const getUserPincode = () => {
    dispatch(getUserProfile())
      .unwrap()
      .then(res => {
        let userPincode = ""
        const addresses = res.addresses ?? []
        const { defaultShippingAddressId } = res ?? ""
        if (addresses.length) {
          userPincode = addresses.find(
            add => add.id === defaultShippingAddressId
          )?.postalCode
        }
        setPincode(userPincode)
      })
  }

  const setCookie = () => {
    if (pincode) {
      document.cookie = `pincode=${pincode}; path=/`
    }
  }

  const getCookieValue = name =>
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""

  const deleteCookieValue = name => {
    setAvailableQty(0)
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"
  }

  useEffect(() => {
    const availablePincode = getCookieValue("pincode")
    if (availablePincode) {
      setPincode(availablePincode)
    } else if (isAuth) {
      getUserPincode()
    }
  }, [isAuth])

  useEffect(() => {
    if (isAvailable || error) {
      setError("")
      handleSearch(true)
    } else {
      document.dispatchEvent(stopATCLoading)
    }
  }, [qty, installReq])

  useEffect(() => {
    if (validNumber(pincode) && pincode.length <= 6) {
      setPincodeValue(pincode)
    }
  }, [pincode])

  useEffect(() => {
    disableCart(true)
    setError("")
    setInstallationWarning("")
    setInstallationError(false)
    if (isValidPincode(pincode) && (isBundle || masterSku)) {
      handleSearch()
    }
  }, [pincode, masterSku, isBundle, sku])

  const getInstallProductInfo = (serviceData = {}) => {
    const servicename = serviceData?.name?.["en-IN"] || "n/a"
    const userPersona = persona[0]
    const personaprice = serviceData?.masterVariant?.prices.filter(p =>
      userPersona.includes(p?.customerGroup?.obj?.key)
    )?.[0]
    const unitPrice = personaprice?.value?.centAmount
    const discountPrice = personaprice?.discounted?.value?.centAmount
    return {
      description: servicename?.toLowerCase(),
      frequency: "n/a",
      globalPromotionPrice: Number(discountPrice || unitPrice) / 100,
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      priceState: "regular price",
      productBasePrice: unitPrice ? Number(unitPrice) / 100 : "n/a",
      productCategory: "install services",
      productColor: "n/a",
      productCoupondiscount: 0,
      productCouponCode: "n/a",
      productID: serviceData?.masterVariant?.sku || "n/a",
      productName: servicename?.toLowerCase(),
      productPartnerBuyNow: false,
      productRoom: "n/a",
      productSalePrice: Number(discountPrice || unitPrice) / 100,
      productSaleable: true,
      productStatus: "in stock",
      productSuperSku: false,
      productTileName: servicename?.toLowerCase(),
      quantity: 1,
      defaultImageName: "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
      pdpType: "service",
      productFindingMethod: "n/a",
      productCollectionsName: "install services",
      productBrand: "kohler-india",
      globalOffer: "n/a",
      globalDiscount: 0,
      itemType: "service",
      category: "install services",
      waterSenseProduct: "n/a",
    }
  }

  const handleSearch = async isQtyAction => {
    if (isValidPincode(pincode)) {
      if (!isQtyAction) {
        setCookie()
        setPinCodeError(false)
        setAvailability(false)
        setInstallationAvailable(false)
      }

      setReqItemsError({})
      setLoading(true)
      setIsEtaLoading(true)
      const payload = {
        pincode,
        qty,
      }
      if (isBundle) {
        if (installReq?.length > 0) {
          let getProducts = installReq?.map(item => {
            return { sku: item?.skuid, mastervariantkey: item?.inRiverId }
          })
          ;(payload.action = "must-order"),
            (payload.products = [
              { sku: sku, mastervariantkey: sku },
              ...getProducts,
            ])
        } else {
          payload.mastervariantkey = sku
          payload.sku = sku
          payload.type = "Sales"
        }
      } else {
        if (installReq?.length > 0) {
          let getProducts = installReq?.map(item => {
            return {
              sku: item?.skuid,
              mastervariantkey:
                item?.inRiverId !== "" ? item?.inRiverId : item?.skuid,
            }
          })
          ;(payload.action = "must-order"),
            (payload.products = [
              { sku: sku, mastervariantkey: masterSku },
              ...getProducts,
            ])
        } else {
          payload.mastervariantkey = masterSku
          payload.sku = sku
          payload.type = "Sales"
        }
      }
      try {
        const isMustOrder = installReq?.length > 0
        const data = await getETACached(isBundle, payload, isMustOrder)
        if (data?.data?.status === "fail" && data?.data?.statusCode === 404) {
          setError(data?.data?.result?.error || data?.data?.result?.data?.error)
          setIsOutOfStock(
            data?.data?.result?.error || data?.data?.result?.data?.error
          )
          disableCart(true)
          setAvailability(false)
          setInstallationData({
            isInstallation: false,
            name: "",
            price: "",
          })
          setInstallationWarning(i18n.installServiceNotAvailableMsg)
          setInstallationAvailable(false)
          setLoading(false)
          setIsEtaLoading(false)
          setHideSimilarItems(true)
          showSimilarItems = false
          return
        }
        setHideSimilarItems(false)
        if (isBundle) {
          setWareHouses(data.result?.data?.warehouse)
          data.result.data = data.result?.data
        }
        if (isMustOrder) {
          const errorData = {}

          data.result?.data.forEach(item => {
            if (item.result?.error) {
              errorData[item.sku] = item.result.error
            }
          })
          setReqItemsError(errorData)
          data.result = data.result?.data[0]?.result
        }
        const {
          result: {
            data: { eta = {}, warehouse = [], installationService = {} } = {},
            error = "",
          } = {},
        } = data
        if (Object.keys(eta)?.length > 0) {
          if (warehouse?.length) {
            const _availableQty = warehouse?.reduce(
              (acc, cur) => acc + cur.availableQty,
              0
            )
            setAvailableQty(_availableQty)
            setWareHouses(warehouse)
          }
          if (
            !isQtyAction ||
            (isQtyAction &&
              installationService?.isInstallation &&
              !installServiceData?.isInstallation)
          ) {
            if (Object.keys(installationService).length > 0) {
              if (installationService?.isInstallation) {
                const response = await getProductBySku(
                  installationService?.name
                )
                const mrpPrice = response?.masterVariant?.prices.filter(
                  p => !p?.customerGroup
                )?.[0]
                const userPersona = getUserPersona() || "IN_Kohler_ISC"
                const personaprice = response?.masterVariant?.prices.filter(p =>
                  userPersona.includes(p?.customerGroup?.obj?.key)
                )?.[0]
                setInstallationData({
                  isInstallation: installationService?.isInstallation,
                  name: response?.name["en-IN"],
                  installServiceSKU: installationService.name,
                  sku: installationService.name,
                  mrpPrice: mrpPrice?.value?.centAmount,
                  price:
                    personaprice?.discounted?.value?.centAmount ||
                    personaprice?.value?.centAmount,
                })
                setInstallationMsg(i18n.installServiceAvailableMsg)
                setInstallationAvailable(true)
                const installProductInfo = getInstallProductInfo(response)
                setInstallProductInfo(installProductInfo)
              } else {
                setInstallationData({
                  isInstallation: installationService?.isInstallation,
                  name: "",
                  price: "",
                })
                setInstallationMsg("")
                setInstallationWarning(i18n.installServiceNotAvailableMsg)
                setInstallationError("")
                setInstallationAvailable(false)
              }
            } else {
              setInstallationData({
                isInstallation: installationService?.isInstallation,
                name: "",
                price: "",
              })
              setInstallationWarning(
                i18n.installServiceNotAvailableforProductMsg
              )
              setInstallationAvailable(false)
            }
          }
          setEta(eta)
          setAvailability(true)
          setPinCodeError(false)
          disableCart(false)
          const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "pdp:product details:check availability",
            eventName: "pdp:product details:check availability",
            eventType: "navigation",
            internalLinkName: "check availability",
            internalLinkPosition: "pdp",
            internalLinkType: `pdp:${pincode}`,
            internalLinkZoneName: "pdp:product details",
            internalLinkURL: "n/a",
            pincode: pincode,
          }
          productInfo.pincode = pincode
          const page = window?.adobeDataLayer?.getState("page")
          page.productInfo.pincode = pincode
          const customDataLayer = { productInfo, page }

          pushAnalyticsObjToDataLayer(
            eventInfo,
            "cmp:click",
            {},
            customDataLayer
          )
        } else if (error) {
          setError(error)
          disableCart(true)
          setAvailability(false)
          setInstallationData({
            isInstallation: false,
            name: "",
            price: "",
          })
          setIsOutOfStock(error)
          setInstallationWarning(i18n.installServiceNotAvailableMsg)
          setInstallationAvailable(false)
        }

        setLoading(false)
        setIsEtaLoading(false)
        document.dispatchEvent(stopATCLoading)
      } catch (err) {
        const { response: { data: errData = {} } = {} } = err
        setError(
          errData.statusCode === 404 && errData.status === "fail"
            ? isBundle
              ? i18n.notDeliverBundleMsg
              : i18n.notDeliverErrorMsg
            : errData.result?.error ?? i18n.pincodeApiFailMsg
        )
        setInstallationWarning("")
        disableCart(true)
        setInstallationData({
          isInstallation: false,
          name: "",
          price: "",
        })
        setLoading(false)
        setIsEtaLoading(false)
        document.dispatchEvent(stopATCLoading)
        console.error(err)
      }
    } else {
      setError(i18n.validPincode)
      setLoading(false)
      setIsEtaLoading(false)
      document.dispatchEvent(stopATCLoading)
      setInstallationWarning("")
    }
  }
  const navigateToSimilarItems = () => {
    const element = document.getElementById("product-recs-AT-Similar-items")
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      })
    }
  }

  const handleKeyDown = e => {
    const { KEYCODE } = CONSTANTS
    if (e.keyCode === KEYCODE.ENTER) {
      handleSearch()
    }
  }
  const handleChange = ({ target: { value = "" } = {} }) => {
    setNotifySuccess(false)
    setIsOutOfStock("")
    if (validNumber(value) && value.length <= 6) {
      setPincode(value)
      setAvailability(false)
      deleteCookieValue("pincode")
    }
  }

  const addChangeAnalytics = () => {
    const eventInfo = {
      clickInternalLinks: "true",
      eventAction: "pdp:product details:pincode change",
      eventName: "pdp:product details:pincode change",
      eventType: "navigation",
      internalLinkName: "change",
      internalLinkPosition: "pdp",
      internalLinkType: "pdp:pincode change",
      internalLinkZoneName: "pdp:product details",
      internalLinkURL: "n/a",
    }
    const customDataLayer = { productInfo }
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, customDataLayer)
  }

  return (
    <div className={styles.pdpInstallServiceWrapper}>
      <div className="pdp-install-service">
        <div
          className={`title ${
            !error && !installationError && !installationWarning ? "mt-5" : ""
          }`}
        >
          {!installationAvailable || !isAvailable ? (
            <>
              {(installationWarning && !installationError) ||
                (!error && <p className={`title`}>{i18n.serviceTitle}</p>)}
            </>
          ) : null}
        </div>
        {/* {installationWarning && !installationAvailable ? (
          <div className="warning-container pt-10">
            <img
              src={infoIcon?.src}
              alt={installationWarning}
              className="mr-5"
              height={"14px"}
              width={"14px"}
            />
            <p className="warning-msg">{installationWarning}</p>
          </div>
        ) : null} */}
        {isAvailable && (
          <div className="eta">
            {eta ? (
              <>
                <b>
                  {i18n.eta({
                    min: eta.minDay,
                    max: eta.maxDay,
                    pincode: pincode,
                  })}
                </b>
                <button
                  className="change-btn"
                  onClick={() => {
                    disableCart(true)
                    setAvailability(false)
                    setPinCodeError(true)
                    setInstallationWarning("")
                    setError("")
                    setInstallationData({
                      isInstallation:
                        isInstallationAvailable === "Yes" ? true : false,
                      name: "",
                    })
                    addChangeAnalytics()
                  }}
                >
                  {"Change Pincode"}
                </button>
                <div>
                  {i18n.etaMessage({
                    message: installationMsg,
                  })}
                </div>
              </>
            ) : null}
          </div>
        )}
        {!installationAvailable || !isAvailable ? (
          <>
            {(installationWarning && !installationError) ||
              (!error && (
                <p className={`${pinCodeError ? "desc-red" : "desc"}`}>
                  {i18n.serviceDesc}
                </p>
              ))}
            {(error || installationError) && (
              <div
                className={`pincode-error ${
                  !hideSimilarItems && showSimilarItems
                    ? "out-of-stock-div"
                    : ""
                }`}
              >
                <p
                  className={`error-msg ${
                    !hideSimilarItems && showSimilarItems
                      ? "pincode-error__similar-items"
                      : ""
                  }`}
                >
                  {error ? error : installationError}
                </p>
                {!hideSimilarItems && showSimilarItems ? (
                  <span
                    className="view-similar"
                    onClick={navigateToSimilarItems}
                  >
                    View Similar Items
                  </span>
                ) : null}
              </div>
            )}
            <div className="pincode-wrap">
              <div className="pincode-input">
                <Input
                  id="pdp-install-service-pincode"
                  type="text"
                  value={pincode}
                  label={i18n.pincodeLabel}
                  placeholder={i18n.pincodeLabel}
                  onChange={handleChange}
                  onBlur={() => {}}
                  haspopup={false}
                  onKeyDown={handleKeyDown}
                />
              </div>
              <div className="pincode-btn">
                {pincode !== "" ? (
                  <Button
                    type="ghost"
                    size="small"
                    role="button"
                    loading={loading}
                    onClick={handleSearch}
                    label={i18n.search}
                  />
                ) : null}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default InstallService
